import { SearchX } from 'lucide-react'
import { Link } from 'react-router'
import { buttonClass } from '../components/Button'
import { EmptyState } from '../components/EmptyState'

export function NotFoundPage() {
  return (
    <EmptyState icon={SearchX} title="Такой страницы нет">
      <Link to="/" className={buttonClass('secondary', 'md', 'mt-3')}>
        К залётам
      </Link>
    </EmptyState>
  )
}
